import { Injectable } from '@angular/core';
import { AppState } from '../../NGRX/core.state';
import { setWebsocketEvent } from '../../NGRX/coreWebsockets/coreWebsockets.actions';
import { Store } from '@ngrx/store';
import Pusher from 'pusher-js';
import { Config } from '../config/config.service';

@Injectable()
export class WebsocketService {
  private socket: any;
  private channels: any = {};

  constructor(
    private _config: Config,
    private store: Store<AppState>
  ) {
  }

  connect(): void {
    if (!this.isConnected()) {
      this.socket = new Pusher(this._config.CONFIG.websocketsKey, {
        wsHost: this._config.CONFIG.websocketsUrl,
        cluster: this._config.CONFIG.websocketCluster,
        disableStats: true,
        enabledTransports: ['ws']
      });

      this.subscribeChannel('pools');
      this.bindAllChannelEvents('pools');
    }
  }

  subscribe(channel: string) {
    this.socket.subscribe(channel);
  }

  isConnected(): boolean {
    if (typeof this.socket !== 'undefined') {
      if (this.socket.connection.state === 'connected' || this.socket.connection.state === 'connecting') {
        return true;
      }
    }
    return false;
  }

  closeConnection() {
    if (this.isConnected()) {
      this.socket.disconnect();
      this.channels = {};
    }
  }

  subscribeChannel(channelName: string) {
    if (typeof this.channels[channelName] === 'undefined') {
      let channel = this.socket.subscribe(channelName);
      this.channels[channelName] = channel;
    }
  }

  unSubscribeChannel(channelName: string) {
    if (typeof this.channels[channelName] !== 'undefined') {
      this.socket.unsubscribe(channelName);
      this.channels[channelName] = undefined;
    }
  }

  bindAllChannelEvents(channelName: string) {
    // let self = this;
    // in some cases, at refresh, the socket is not yet present
    // and leads to application to break
    try {
      this.socket.allChannels().forEach((channel: any) => {
        if (channel.subscribed === false) {
          channel.bind_global((event: any, data: any) => {
            if (channel.name === 'pools') {
              // this._notificationService.handleEvents(event, data);
              this.handlePoolEvents(event, data);
            }
          })
        }
      });
    } catch (e: any) {
      this.bindAllChannelEvents(channelName);
    }
  }

  handlePoolEvents(event: string, data: any): void {
    const basicEvents: Record<string, string> = {
      'show': 'POOL_SHOW',
      'hide': 'POOL_HIDE',
      'trading_enabled': 'TRADING_ENABLED',
      'trading_disabled': 'TRADING_DISABLED'
    };

    if (basicEvents[event]) {
      // Hard check to have correct data from WS and not to refresh all things!!!
      let correctData: unknown = undefined;
      if (data?.object_id) {
        correctData = data;
      } else if (data?.data?.object_id) {
        correctData = data.data;
      }
      if (correctData) {
        this.store.dispatch(setWebsocketEvent({
          event: basicEvents[event],
          data: correctData
        }));
      }
    }

    if (event === 'cycle_update') {
      // manually update pool menu & pool
      this.store.dispatch(setWebsocketEvent({
        event: 'POOL_INFO_CHANGED',
        data: data?.data
      }));
    }

    if (event === 'competitors_update') {
      // NOTE: to check again
      this.store.dispatch(setWebsocketEvent({
        event: 'SPORT_EVENT_COMPETITORS_UPDATE',
        data: data
      }));
    }

    // reload everything
    if (event === 'status_change') {
      this.store.dispatch(setWebsocketEvent({
        event: 'POOL_STATUS_CHANGED',
        data: data?.data
      }));
    }

    /* NOTE: New events */

    // reload pool - win sel changed
    if (event === 'winnings_update' ||
      event === 'remunit_update' || event === 'unit_update'
    ) {
      this.store.dispatch(setWebsocketEvent({
        event: 'POOL_UPDATED',
        data: data?.data ?? data
      }));
    }


    if (event === 'results_update') {
      this.store.dispatch(setWebsocketEvent({
        event: 'RESULTS_UPDATED',
        data: data
      }));
    }

    // manually update competitor - SINGLE COMPETITOR
    if (event === 'competitor_update') {
      this.store.dispatch(setWebsocketEvent({
        event: 'SPORT_EVENT_COMPETITOR_UPDATE',
        data: data
      }));
    }


    // manually update sport event
    if (event === 'sport_event_update')
      this.store.dispatch(setWebsocketEvent({
        event: 'SPORT_EVENT_UPDATE',
        data: data
      }));


    if (event === 'metric_update') {
      this.store.dispatch(setWebsocketEvent({
        event: 'METRIC_UPDATE',
        data: data
      }));
    }

    if (event === 'player_update') {
      this.store.dispatch(setWebsocketEvent({
        event: 'PLAYER_UPDATE',
        data: data
      }));
    }

    // reload ticket & pool
    // remove as obsolete - they don't exist in BE anymore
    // if (data && data.route) {
    //   if (data.route.indexOf('tote_controller.pools') !== -1) {
    //     this.store.dispatch(setWebsocketEvent({
    //       event: 'POOL_UPDATED',
    //       data: data?.data
    //     }));
    //   }
    // }

    // reload pool & ticket & ticket menu
    // remove as obsolete - they don't exist in BE anymore
    // if (data && data.route) {
    //   if (data.route.indexOf('remunit_controller.pools') !== -1) {
    //     this.store.dispatch(setWebsocketEvent({
    //       event: 'UNIT_DISTRIBUTION_CHANGED',
    //       data: data?.data
    //     }));
    //   }
    // }

    /* NOTE: Will be deprecated  */
    // if (event !== 'external_db_update') return;
  }
}
